import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ShimmerTextProps {
  children: ReactNode;
  loading?: boolean;
  className?: string;
}

const ShimmerTextStyled = styled.span<{ $loading?: boolean }>`
  ${({ $loading }) =>
    $loading &&
    css`
      animation: fadeInOut 2s ease-in-out infinite;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 1) 50%,
        rgba(0, 0, 0, 0.2) 100%
      );
      background-size: 200% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      @keyframes fadeInOut {
        0% {
          background-position: 100% 50%;
        }
        100% {
          background-position: -100% 50%;
        }
      }
    `};
`;

export const ShimmerText = ({
  children,
  loading,
  className,
}: ShimmerTextProps) => {
  return (
    <ShimmerTextStyled $loading={loading} className={className}>
      {children}
    </ShimmerTextStyled>
  );
};
